<template>
    <router-link :to="to" class="nav-link" :class="(inGroup) ? 'active' : null" :aria-current="(inGroup) ? 'page' : null">
        <slot/>
    </router-link>
</template>

<script type="text/javascript">

    export default {

        props: {
            to: {
                type: String,
                required: true,
            },

            //  when the route.meta.group matches this, active class will be added
            group: {
                type: String,
            },
        },

        computed: {
            inGroup() {
                if ((this.$route.meta) && (this.group) && (this.$route.meta.group == this.group)) {
                    return true;
                }

                return false;
            }
        },

        
    };

</script>
